import waitonCreate from "../../../assets/load.gif";
import "./newWO.css";

const NewWoCreated = ({
  wono,
  setLoading,
  updateWoList,
  addingFiles,
  exitWindow,
  createWoError,
  setCreateWoError,
  createWO,
  nameOfUser,
  generatingPDF,
}) => {
  const exitWindowWoCre = async () => {
    updateWoList();
    setLoading(false);
    exitWindow();
  };

  const retryWoCre = async () => {
    setCreateWoError(false);
    setLoading(false);
    createWO();
  };

  const abortWoCre = async () => {
    setCreateWoError(false);
    setLoading(false);
  };

  return (
    <div className="divNewWOCreated">
      {createWoError === false ? (
        wono.length > 2 ? (
          wono.length === 8 ? (
            <>
              <p className="mb-5 mt-5 fs-5">
                Tack för din beställning {nameOfUser}!
              </p>
              <p className="mb-5 fs-5">Beställning {wono} är nu skapad.</p>
              <p className="fs-5">
                En sammanfattning av din beställning hittar du i bifogade filer
                för denna beställning.
              </p>
              {(addingFiles || generatingPDF) && (
                <>
                  <p>Innehåll läggs till i beställningen, vänta...</p>
                  <img
                    src={waitonCreate}
                    alt="loading..."
                    className="loadGif"
                  />
                </>
              )}
            </>
          ) : (
            <p>Något gick fel: {wono}</p>
          )
        ) : (
          <>
            <p>Beställning skapas...</p>
            <img src={waitonCreate} alt="loading..." className="loadGif" />
          </>
        )
      ) : (
        <></>
      )}

      {createWoError === false ? (
        <>
          <br />
          <br />
          <button
            className="btn"
            onClick={exitWindowWoCre}
            disabled={wono.length !== 8 || addingFiles || generatingPDF}
          >
            Stäng
          </button>
        </>
      ) : (
        <div>
          <p className="errorMessage">
            Beställning gick inte att skapa, försök igen eller kontakta Eltel
            SPOC om problemet kvarstår.
          </p>
          <br />
          <br />
          <button className="btn" onClick={retryWoCre}>
            Försök igen
          </button>
          <button className="btn" onClick={abortWoCre}>
            Avbryt
          </button>
        </div>
      )}
    </div>
  );
};

export default NewWoCreated;
